import { render, staticRenderFns } from "./BoContactPage.vue?vue&type=template&id=a98d7f98&scoped=true"
import script from "./BoContactPage.vue?vue&type=script&lang=js"
export * from "./BoContactPage.vue?vue&type=script&lang=js"
import style0 from "./BoContactPage.vue?vue&type=style&index=0&id=a98d7f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d7f98",
  null
  
)

export default component.exports